export default "__VITE_ASSET__DJLGmy47__"